import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { colorCodesForAvatar } from "../../../../../constants/index";
import { chracterPosition } from "../../../../../utils/index";
import { peopleEllipsisSx } from "../../peopleFormValidation";

export default function CustomerDetailProfile({ customer }) {
  const letter = (customer.name || "").substring(0, 1).toUpperCase();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0, width: "100%" }}>
      {customer.avatar ? (
        <Avatar src={customer.avatar} alt={customer.name} sx={{ width: 56, height: 56, flexShrink: 0 }} />
      ) : (
        <Avatar
          sx={{
            width: 56,
            height: 56,
            fontSize: 20,
            flexShrink: 0,
            bgcolor: colorCodesForAvatar[chracterPosition(letter)] || "#405261",
          }}
        >
          {letter}
        </Avatar>
      )}
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          title={customer.name}
          sx={{
            color: "#061522",
            fontFamily: "Inter",
            fontSize: 18,
            fontWeight: 500,
            lineHeight: "34px",
            ...peopleEllipsisSx,
          }}
        >
          {customer.name}
        </Typography>
        <Typography
          title={customer.company}
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "18px",
            ...peopleEllipsisSx,
          }}
        >
          {customer.company}
        </Typography>
      </Box>
    </Box>
  );
}
